import type { InputSignal } from '@angular/core';
import { Component, input } from '@angular/core';

import type { StoryblokRichTextDoc } from '@storyblok/richtext';
import { MarkdownComponent } from 'ngx-markdown';

import type { HeadingType } from '@valk-nx/core/lib/directives/heading/heading.type';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';
import { HeadingGroupComponent } from '@valk-nx/storyblok/components/heading-group/src/lib/heading-group';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import type { ColumnComponentAlignments } from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';
import { isColumnComponentAlignment } from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

@Component({
	selector: 'sb-heading-group-section',
	templateUrl: './heading-group-section.html',
	imports: [
		HeadingGroupComponent,
		MarkdownComponent,
		StoryblokDirective,
		SVG_ICON_IMPORTS,
	],
	host: { class: 'w-full' },
})
export class HeadingGroupSectionComponent extends StoryblokRootDirective {
	title: InputSignal<StoryblokRichTextDoc | string> = input.required<
		StoryblokRichTextDoc | string
	>();
	headingType = input.required<HeadingType>();

	alignment = input<ColumnComponentAlignments, string>('center', {
		transform: (value: string): ColumnComponentAlignments => {
			return isColumnComponentAlignment(value)
				? value
				: ('center' as ColumnComponentAlignments);
		},
	});

	bottomFigure = input<string>('');
	content = input<string>('');
	overline = input<string>('');
	size = input<'sm' | 'md' | 'lg'>('lg');
	topFigure = input<string>('');
}
